import { useEffect } from "react";

const useDropzoneProperties = ({ setDropzoneProperties, properties: { clear, files, errors, ...otherProperties } }) => {
  useEffect(
    () => setDropzoneProperties({ clear, files, errors, ...otherProperties }),
    [clear, files, errors]
  );
};

export default useDropzoneProperties;